import React, { useCallback, useEffect } from "react";
import { Tab } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";

import { MainContainer, TitleContainer } from "components";
import { useApplicationCounters } from "queries";

import ApplicationNav from "./applicationNav";
import {
	AllApplicationsTab,
	SignedMPAsTab,
	PreApplicationsTab,
	PendedTab,
	DraftsTab,
} from "./tabs";

let ApplicationList = () => {
	const history = useHistory();
	const params = useParams<{ tab?: string }>();

	useEffect(() => {
		if (
			!params.tab ||
			![
				"all",
				"signed-mpas",
				"pre-applications",
				"pended",
				"drafts",
			].includes(params.tab)
		) {
			params.tab = "all";
			history.replace(`/applications/all`);
		}
	}, [history, params]);

	const {
		data: counters,
		isLoading: isCountersLoading,
		isFetching: isCountersFetching,
		refetch,
	} = useApplicationCounters();

	const onTabSelect = useCallback(async () => {
		await refetch?.();
	}, [refetch]);

	return (
		<MainContainer className="container-flex">
			<TitleContainer>
				<h1>Application List</h1>
			</TitleContainer>
			<Tab.Container
				activeKey={params.tab}
				onSelect={onTabSelect}
				mountOnEnter
				unmountOnExit
			>
				<ApplicationNav
					counters={counters}
					isCountersLoading={isCountersLoading || isCountersFetching}
				/>
				<Tab.Content className="container-flex">
					<Tab.Pane eventKey="all" className="container-flex">
						<AllApplicationsTab />
					</Tab.Pane>
					<Tab.Pane eventKey="signed-mpas" className="container-flex">
						<SignedMPAsTab />
					</Tab.Pane>
					<Tab.Pane
						eventKey="pre-applications"
						className="container-flex"
					>
						<PreApplicationsTab />
					</Tab.Pane>
					<Tab.Pane eventKey="pended" className="container-flex">
						<PendedTab />
					</Tab.Pane>
					<Tab.Pane eventKey="drafts" className="container-flex">
						<DraftsTab />
					</Tab.Pane>
				</Tab.Content>
			</Tab.Container>
		</MainContainer>
	);
};

export { ApplicationList };
